import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeHelpArticleSkeleton } from './TypeHelpArticle'
import type { TypeHelpSubcategorySkeleton } from './TypeHelpSubcategory'

export interface TypeHelpCategoryFields {
  title: EntryFieldTypes.Symbol
  items: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeHelpArticleSkeleton | TypeHelpSubcategorySkeleton>>
}

export type TypeHelpCategorySkeleton = EntrySkeletonType<TypeHelpCategoryFields, 'helpCategory'>
export type TypeHelpCategory<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeHelpCategorySkeleton,
  Modifiers,
  Locales
>

export function isTypeHelpCategory<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeHelpCategory<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'helpCategory'
}
